import { TwoColumnLayout } from '@workspace/ui/components/layout/two-column'
import type { ReactNode } from 'react'

interface LoginLayoutProps {
  children: ReactNode
}

export function LoginLayout({ children }: LoginLayoutProps) {
  return (
    <TwoColumnLayout>
      <TwoColumnLayout.Cover />
      <TwoColumnLayout.Content>{children}</TwoColumnLayout.Content>
    </TwoColumnLayout>
  )
}
